import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — spiral stair. Fits a single 1x1 tile: a matte-black centre
// pole with eight oak wedge treads winding one full turn up to y = 2.6,
// ending on a small top platform level with the last tread.
const OAK = "#c8975a";
const BLACK = "#2e2e30";

const STEPS = 8;
const RISE = 2.6 / STEPS; // 0.325 per tread
const RADIUS = 0.27; // tread centre distance from the pole

export const stairsSpiral = defineModel({
  id: "stairs-spiral",
  batchId: "modern",
  name: "Spiral stairs",
  tags: ["modern", "interior", "structure", "stairs"],
  summary: "A compact spiral stair on a single tile, climbing one storey.",
  description:
    "The spiral stair of the Modern Living kit: a 1x1 tile footprint, a " +
    "matte-black centre pole and eight oak wedge treads winding one full " +
    "turn up to 2.6 m, with a small top platform at storey height.",
  tiles: { w: 1, h: 1 },
  footprint: 1.5,
  parts(): Part[] {
    const parts: Part[] = [
      // Centre pole.
      { geometry: new THREE.CylinderGeometry(0.05, 0.05, 2.6, 10), color: BLACK, position: [0, 1.3, 0] },
    ];
    for (let i = 0; i < STEPS; i++) {
      const angle = (i * Math.PI * 2) / STEPS;
      const top = (i + 1) * RISE;
      parts.push({
        geometry: new THREE.BoxGeometry(0.45, 0.05, 0.26),
        color: OAK,
        position: [RADIUS * Math.cos(angle), top - 0.025, -RADIUS * Math.sin(angle)],
        rotation: [0, angle, 0],
      });
    }
    // Small top platform, one step past the last tread (a full turn).
    parts.push({
      geometry: new THREE.BoxGeometry(0.48, 0.05, 0.42),
      color: OAK,
      position: [RADIUS, 2.6 - 0.025, 0],
    });
    return parts;
  },
  animations: [],
});
